import React, { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { Hourglass, History } from "lucide-react";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { useOrariTurni } from "../lib/orari";
import { PopupAvviso, testo } from "./PopupAvviso";

const FINESTRA = 30;
const LBL = { docce: ["Docce", "/docce"], checklist: ["Check-list sanitaria", "/check-list-sanitaria"], checklist_motivo: ["Check-list con motivo", "/check-list-sanitaria"], parametri: ["Parametri", "/parametri"], non_alzati: ["Alzate", "/alzate"], non_messi_letto: ["Messa a letto", "/messa-a-letto"], alvo: ["Alvo", "/alvo"], pulizie: ["Pulizie", "/pulizie"], consegne: ["Consegne", "/consegne"], dashboard: ["Dashboard non vista", "/"] };
const m = (s) => Number(s.slice(0, 2)) * 60 + Number(s.slice(3, 5));
const iso = (d) => d.toLocaleDateString("sv-SE", { timeZone: "Europe/Rome" });
const ORD = ["mattina", "pomeriggio", "notte"];

// in quale finestra siamo: ultimi 30 min del turno (fine) o primi 30 min del successivo (inizio)
const finestra = (o, prima, dopo) => {
  const now = new Date(); const n = m(now.toLocaleTimeString("it-IT", { hour: "2-digit", minute: "2-digit", timeZone: "Europe/Rome" }));
  const oggi = iso(now); const ieri = iso(new Date(now.getTime() - 86400000));
  for (const t of ORD) {
    const ini = m(o[t].inizio), fin = m(o[t].fine);
    const dEnd = (fin - n + 1440) % 1440;
    if (dEnd > 0 && dEnd <= prima) return { tipo: "fine", turno: t, data: t === "notte" && n < ini ? ieri : oggi, fine: o[t].fine };
    const dStart = (n - ini + 1440) % 1440;
    if (dStart < dopo) {
      const prev = ORD[(ORD.indexOf(t) + 2) % 3];
      return { tipo: "inizio", turno: prev, data: t === "mattina" ? ieri : oggi, ora: o[t].inizio };
    }
  }
  return null;
};

export default function FineTurnoPopup() {
  const { selectedStructure, user } = useAuth();
  const nav = useNavigate();
  const orari = useOrariTurni(selectedStructure);
  const [, setTick] = useState(0);
  useEffect(() => { const i = setInterval(() => setTick((x) => x + 1), 60000); return () => clearInterval(i); }, []);
  const { data: cfg } = useQuery({ enabled: !!user, queryKey: ["solleciti-cfg"], staleTime: 300000, queryFn: async () => (await api.get("/solleciti/impostazioni")).data });
  const f = user ? finestra(orari, cfg?.fine_prima_min || FINESTRA, cfg?.fine_dopo_min || FINESTRA) : null;
  const sid = selectedStructure && selectedStructure !== "all" ? selectedStructure : "all";
  const { data } = useQuery({
    enabled: !!f, queryKey: ["cosa-manca", f?.data, f?.turno, sid], refetchInterval: 120000,
    queryFn: async () => { try { return (await api.get("/dashboard/cosa-manca", { params: { data: f.data, turno: f.turno, structure_id: sid } })).data; } catch { return null; } },
  });
  const voci = (data?.categorie || []).filter((c) => LBL[c.key] && !c.nessun_turno && c.items.length > 0);
  const chiave = f ? `fineturno-${f.tipo}-${f.data}-${f.turno}-${sid}` : null;
  const visto = chiave && localStorage.getItem(chiave);
  const chiudi = () => { localStorage.setItem(chiave, "1"); setTick((x) => x + 1); };
  const aperto = !!f && voci.length > 0 && !visto;
  const fine = f?.tipo === "fine";
  return (
    <PopupAvviso open={aperto} onClose={chiudi} tono={fine ? "amber" : "red"} Icon={fine ? Hourglass : History} testid="fineturno-popup"
      titolo={testo(cfg, fine ? "fine_titolo" : "inizio_titolo")} descr={testo(cfg, fine ? "fine_testo" : "inizio_testo", { turno: f?.turno, ora: f?.fine })}
      voci={voci.map((c) => ({ key: c.key, label: LBL[c.key][0], count: c.items.length, path: LBL[c.key][1] }))} onVai={(v) => { chiudi(); nav(v.path); }} />
  );
}
